
import { Component, Prop, Ref, mixins, namespace } from 'nuxt-property-decorator';
import { Modal } from 'fourwaves-shared/components';
import { TranslateResult } from 'vue-i18n';
import UpgradeMixin from './UpgradeMixin';
import { UpgradeCheckoutEvents } from './types';

const SettingsModule = namespace('settings');

@Component({
  components: {
    Modal,
  },
})
export default class UpgradeModal extends mixins(UpgradeMixin) {
  @SettingsModule.Getter isEventAdministrator!: boolean;
  @Prop({ type: String, default: '' }) title!: string;
  @Prop({ type: String, default: '' }) subtitle!: string;

  @Ref() readonly modal?: Modal;

  get actionLess(): boolean {
    return !this.isEventAdministrator;
  }

  get modalTitle(): TranslateResult {
    if (this.title) return this.title;
    if (!this.isEventAdministrator) return this.$t('plans.upgrade_modal.no_admin_title');
    return this.feature ? this.$t(`plans.upgrade_modal.${this.feature}.title`) : '';
  }

  get modalSubtitle(): TranslateResult {
    if (this.subtitle) return this.subtitle;
    if (!this.isEventAdministrator) return this.$t('plans.upgrade_modal.no_admin_message');
    return this.feature ? this.$t(`plans.upgrade_modal.${this.feature}.message`) : '';
  }

  created() {
    this.$nuxt.$on(UpgradeCheckoutEvents.Initiated, this.close);
  }

  beforeDestroy() {
    this.$nuxt.$off(UpgradeCheckoutEvents.Initiated, this.close);
  }

  public async open(targetElement?: HTMLButtonElement | EventTarget | null) {
    await this.$nextTick();
    this.returnFocusTarget = targetElement || null;
    this.modal?.open();
  }

  public close() {
    this.modal?.close();
  }
}
